var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22q-.473 0-.792-.32a1.08 1.08 0 0 1-.32-.791v-7.75a8.8 8.8 0 0 1-3.416-.68 8.8 8.8 0 0 1-2.889-1.931 8.7 8.7 0 0 1-1.916-2.89A9 9 0 0 1 2 4.223v-1.11q0-.474.32-.793Q2.637 2 3.11 2h1.111q1.75 0 3.39.68A8.8 8.8 0 0 1 10.5 4.612 8.5 8.5 0 0 1 11.93 6.5q.57 1.028.876 2.194.138-.194.305-.375.167-.18.361-.375a8.8 8.8 0 0 1 2.89-1.93 8.8 8.8 0 0 1 3.416-.68h1.11q.474 0 .793.319.318.32.319.791v1.112a8.8 8.8 0 0 1-.68 3.416 8.8 8.8 0 0 1-1.931 2.89 8.7 8.7 0 0 1-2.875 1.916 8.9 8.9 0 0 1-3.403.666v4.445q0 .473-.32.792-.318.318-.791.319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.64017bf1df069496844d89852a88e7d7.svg";
export { ForwardRef as ReactComponent };